<template>
    <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
        <div class="modal-header d-flex justify-content-center pt-1">
            <h5 class="modal-title text-center">{{ empresaNome }}</h5>
        </div>

        <div class="modal-body">
            <b-card bg-variant="light">
                <b-form @submit.prevent="handleSubmit">
                    <b-row>
                        <b-col>
                            <lg-form-const-select @change="load()" v-model="situacao" id="situacao"
                                :options="optionsFilterSituacao" label="Situação:" />
                        </b-col>

                        <b-col>
                            <lg-form-input id="searchText" label="Descrição:" v-model="searchText" />
                        </b-col>
                        <b-col class="ml-4 d-flex align-items-center">
                            <b-button id="procurar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                                variant="primary" @click="load">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="search" />
                                </div>
                                <b-tooltip target="procurar" title="Localizar" triggers="hover focus"></b-tooltip>
                            </b-button>
                        </b-col>
                        <b-col class="text-right d-flex justify-content-end align-items-center">
                            <b-button v-if="temPrivilegioCadastro()" id="novo" class="ml-3 mr-2 my-2"
                                style="height: 20px" size="sm" pill variant="secondary"
                                @click="showModalAdicionar = true">
                                <div class="btn-size-alinhamento">
                                    <b-icon scale="1" icon="plus" />
                                </div>
                                <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #cell(editar)="{ item }">
                        <b-button :disabled="!temPrivilegioEdicao()" id="modificar" class="my-2 text-right" size="sm"
                            pill variant="primary" @click="ModalEditar(item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip target="modificar" title="Editar..." triggers="hover"></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(cpf)="{ item }">
                        {{ cpfFormatter(item.cpf) }}
                    </template>
                    <template v-slot:cell(tipoPessoa)="{ item }">
                        {{ formatarTipoPessoa(item.tipoPessoa) }}
                    </template>
                    <template v-slot:cell(dataInicio)="{ item }">
                        {{ $formatDate(item.dataInicio) }}
                    </template>
                    <template v-slot:cell(percentualParticipacao)="{ item }">
                        {{ item.percentualParticipacao ? item.percentualParticipacao + '%' : '-' }}
                    </template>
                    <template v-slot:cell(arquivo)="{ item }">
                        <div v-if="temArquivo(item)" :id="'arquivo-' + item.id">
                            <b-icon icon="file-earmark" class="hand-pointer" @click="downloadArquivo(item)"
                                font-scale="1.2" variant="primary" />
                            <b-tooltip :target="'arquivo-' + item.id" :title="getFileTooltip(item)"
                                triggers="hover"></b-tooltip>
                        </div>
                    </template>
                    <template v-slot:cell(situacao)="{ item }">
                        <div :id="'situacao-' + item.id">
                            <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="item.situacao"
                                @change="alteraSituacao(item)" name="check-button" switch size="lg" :value="1"
                                :unchecked-value="0" class="text-right" />
                            <b-tooltip :target="'situacao-' + item.id" title="Alterar situação" triggers="hover"
                                class="text-right"></b-tooltip>
                        </div>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        Página {{ page }} de {{ totalPage }} - {{ total }} registros
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
                <ModalSocioAdicionar v-if="showModalAdicionar" :codEmpresa="codEmpresa" :prefix="updatedPrefix"
                    @fechar="fechar" :id="idEdit"></ModalSocioAdicionar>
            </b-card>
        </div>
    </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import ResourceService from "@/core/api/ResourceService";
import API from "@/core/api";
import { ListResourceMixin } from "@/core/mixins/resource";
import ModalSocioAdicionar from "./ModalSocioAdicionar.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import FormattersMixin from "@/core/mixins/formatters";
import { cpfFormatter } from "@/utils/cpfUtils";

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        ModalSocioAdicionar,
    },
    props: {
        prefix: Array,
        empresaNome: String,
        codEmpresa: Number,
    },
    data() {
        return {
            showModal: true,
            showModalAdicionar: false,
            idEdit: null,
            searchText: "",
            situacao: 1,
            busy: false,
            optionsFilterSituacao: [
                { key: "filterSituacao", text: "Todos", value: undefined },
                { key: "filterSituacao", text: "Ativo", value: "1" },
                { key: "filterSituacao", text: "Inativo", value: "0" },
            ],
        };
    },
    mounted() {
        this.load();
    },
    mixins: [ListResourceMixin, ConfirmMixin, FormattersMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/socio-empresa`);
    },
    watch: {
        page() {
            this.load()
        },
    },

    computed: {
        updatedPrefix() {
            return [...this.prefix, "Pessoas"];
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
        tableFields() {
            return [
                { key: "nome", label: "Nome", tdClass: "px-2" },
                { key: "cargo", label: "Cargo", tdClass: "px-2" },
                { key: "cpf", label: "CPF", tdClass: "px-2" },
                { key: "tipoPessoa", label: "Tipo de Pessoa", tdClass: "px-2" },
                { key: "dataInicio", label: "Data de Início", tdClass: "px-2" },
                { key: "percentualParticipacao", label: "% Participação", tdClass: "px-2" },
                { key: "arquivo", label: "", tdClass: "text-center" },
                { key: "editar", label: "", tdClass: "text-right" },
                { key: "situacao", label: "", tdClass: "text-left" },
            ];
        },
    },
    methods: {
        temArquivo(item) {
            return (item.tipoPessoa === 'PROCURADOR' && item.codArquivoProcuracao) ||
                (item.tipoPessoa === 'RESPONSAVEL_TECNICO' && item.codArquivoDocumentoResponsavelTecnico) ||
                (item.tipoPessoa === 'PREPOSTO' && item.codArquivoDocumentoDesignacao);
        },
        getFileTooltip(item) {
            if (item.tipoPessoa === 'PROCURADOR') {
                return 'Arquivo de Procuração';
            } else if (item.tipoPessoa === 'RESPONSAVEL_TECNICO') {
                return 'Documento do Responsável Técnico';
            } else if (item.tipoPessoa === 'PREPOSTO') {
                return 'Documento de Designação';
            }
            return 'Arquivo';
        },
        async downloadArquivo(item) {
            let arquivoId = null;

            if (item.tipoPessoa === 'PROCURADOR' && item.codArquivoProcuracao) {
                arquivoId = item.codArquivoProcuracao;
            } else if (item.tipoPessoa === 'RESPONSAVEL_TECNICO' && item.codArquivoDocumentoResponsavelTecnico) {
                arquivoId = item.codArquivoDocumentoResponsavelTecnico;
            } else if (item.tipoPessoa === 'PREPOSTO' && item.codArquivoDocumentoDesignacao) {
                arquivoId = item.codArquivoDocumentoDesignacao;
            }

            if (arquivoId) {
                try {
                    // Fazer o download diretamente usando API
                    const response = await API.get(`/api/arquivos/${arquivoId}/download`, {
                        responseType: 'blob'
                    });

                    // Criar um URL para o blob e iniciar o download
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;

                    // Usar o formato de nome de arquivo conforme requisito: ARQUIVO_+tipo pessoa do socio+_+nome do socio+.pdf
                    let tipoPessoaFormatado = this.formatarTipoPessoa(item.tipoPessoa);
                    let fileName = 'ARQUIVO_' + tipoPessoaFormatado + '_' + item.nome + '.pdf';

                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();

                    // Limpar
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(link);
                } catch (error) {
                    console.error('Erro ao baixar o arquivo:', error);
                    this.$notify({
                        type: 'danger',
                        message: 'Erro ao baixar o arquivo'
                    });
                }
            }
        },
        cpfFormatter(value) {
            return cpfFormatter(value);
        },
        formatarTipoPessoa(tipo) {
            const tiposPessoa = {
                "SOCIO": "Sócio",
                "ADMINISTRADOR": "Administrador",
                "PROCURADOR": "Procurador",
                "RESPONSAVEL_TECNICO": "Responsável Técnico",
                "PREPOSTO": "Preposto"
            };
            return tiposPessoa[tipo] || tipo;
        },
        temPrivilegioCadastro() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);

        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

        },


        ModalEditar(item) {
            this.idEdit = item.id;
            this.showModalAdicionar = true;
        },
        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Sócio?",
                item.nome
            )
            if (response) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },

        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);

            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                });
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                });
            }
        },
        handleSubmit(event) {
            event.preventDefault();
            this.load();
        },
        async load() {
            this.busy = true;
            var filtro = {};
            if (this.codEmpresa) {
                filtro.codEmpresa = this.codEmpresa;
            }
            if (this.searchText) {
                filtro.pesquisaSocio = this.searchText;
            }
            if (this.situacao != undefined) {
                filtro.situacao = this.situacao;
            }

            await this.$loadResource({
                limit: this.perPage,
                page: this.page,
                params: filtro,
            });
            this.busy = false;
        },
        cancelar() {
            this.$emit("close");
        },
        fechar() {
            this.showModalAdicionar = false;
            this.idEdit = null;
            this.load();
        },
    },
};
</script>
<style scoped>
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    padding-top: 1rem;
}

.hand-pointer {
    cursor: pointer;
}
</style>
